module.exports = __webpack_public_path__ + "static/img/zhzq-bg.b2824a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhzq-bg.png
// module id = 1DET
// module chunks = 3